import React, { useState } from 'react'

// query
import { useMutation } from '@apollo/client'
import { BULK_CREATE_ADJUSTMENT_LOGS } from '../../../../../graphql/inventoryAdjustmentLog/inventoryAdjustmentLog.mutations'

// utils
import { createSubmitData } from './AdjustmentLog.form.controller.utils'
import { validate } from '../../../../../shared/utility'

// collections
import AdjustmentForm from './Adjustment.form'

// components
import SideViewModal from '../../../../../components/modals/SideViewModal/SideViewModal.component'

const validationSchema = {
    'date': {
        type: 'date',
        validation: {
            required: true
        }
    },
    'time': {
        type: 'time',
        validation: {
            required: true
        }
    },
    equipment: {
        type: 'list',
        fields: {
            quantity: {
                type: 'input',
                validation: {
                    required: true
                }
            },
            reason: {
                type: 'input',
                validation: {
                    required: true
                }
            }
        }
    }
}

export default function AdjustmentLogFormController({ visible, closeForm }) {

    const [createAdjustmentLogs, ] = useMutation(BULK_CREATE_ADJUSTMENT_LOGS)
    const [errors, setErrors] = useState({ equipment: []})
    // handle the form submission
    const handleSubmit = (formData) => {
        const { isValid, errors } = validate(formData, validationSchema)
        
        if(isValid) {
            const submitData = createSubmitData(formData)
            createAdjustmentLogs({ variables: {...submitData}, refetchQueries:[]}).catch(e => {
                console.error(e)
            }).then(result => {
                if(result) {
                    setErrors({ equipment: []})
                    closeForm()
                }
            })
        } else {
            setErrors(errors)
        }
        
    }

    if(visible) {
        const variants = [
            {
                name: 'Make Adjustment',
                component: <AdjustmentForm />,
                stages: 1
            }
        ]
        return (<SideViewModal 
            show={visible} 
            submitText='Add Adjustments'
            onSubmit={handleSubmit}
            onClose={() => {
                setErrors({ equipment: [] })
                closeForm()
            }} 
            title='Inventory Adjustment'
            variants={variants}    
            errors={errors}
        />)
    }

    return null
}